import { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem('cart'));
    const cartTimestamp = localStorage.getItem('cartTimestamp');

    if (storedCart && cartTimestamp) {
      const elapsedTime = Date.now() - parseInt(cartTimestamp, 10);
      if (elapsedTime < 15 * 60 * 1000) {
        setCart(storedCart);
      } else {
        localStorage.removeItem('cart');
        localStorage.removeItem('cartTimestamp');
      }
    }
  }, []);

  useEffect(() => {
    if (cart.length > 0) {
      localStorage.setItem('cart', JSON.stringify(cart));
      localStorage.setItem('cartTimestamp', Date.now().toString());
    }
  }, [cart]);

  return (
    <CartContext.Provider value={{ cart, setCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
